import { render, staticRenderFns } from "./OtpActivationForm.vue?vue&type=template&id=6fe73d3e"
import script from "./OtpActivationForm.vue?vue&type=script&lang=js"
export * from "./OtpActivationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports